module.exports = __webpack_public_path__ + "img/qwex2.156ca1b7.png";